import React, {createRef, RefObject} from 'react'

import PopoverSelector from "../../../../core/gd-components/selector/popover-selector/popover-selector"
import {SpaceProto} from "../../../../core/model2/space/space-proto"
import PopoverSelectorNew from "../../../../core/gd-components/selector/popover-selector/popover-selector-new"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../core/gd-components/buttons/control-button/control-button-standard"
import {ControlButtonSize} from "../../../../core/gd-components/buttons/control-button/@types"
import NavigationMenu_ProjectsLocalSettings from "../../local-settings"
import spacePreferences_PopoverMenuOptions from "../../actions/space-preferences-menu-options";

type Props = {

    space                   : SpaceProto
    localSettings?          : NavigationMenu_ProjectsLocalSettings

    // value                 : ProjectsTreeSortType

    className?              : string

    onChange?               : callback
    onReset?                : callback
}

// const debug = "NavigationMenu_SpacePreferences"
const debug = false

export default function NavigationMenu_SpacePreferences(props: Props) {

    const popoverSelectorRef: RefObject<PopoverSelector> = createRef<PopoverSelector>()

    debug && console.log(debug, "space=", props.space)
    debug && console.log(debug, "projectsSorting=", props.space.projectsSorting, "projectsColorize", props.space.projectsColorize)


    return (
        <PopoverSelectorNew
            button      = {
                (isSelected:boolean, onClick:callback)=>{
                    return (
                        <ControlButtonStandard
                            className   = "m-r-3"
                            type        = {ControlButtonType.MORE}
                            size        = {ControlButtonSize.SIZE_24}
                            isSelected  = {isSelected}
                            onClick     = {onClick}
                        />
                    )
                }
            }
            options     = {spacePreferences_PopoverMenuOptions(props.space, props.localSettings, props.onReset)}
        />
    )
}
